<template>
<CLink class="btn btn-primary btn-sm min-w-fit-content"
    :href="href"
    :rel="rel"
    :target="target"
    :disabled="disabled"
    :active="active"
    :activeClass="activeClass"
    :append="append"
    :event="event"
    :exact="exact"
    :exactActiveClass="exactActiveClass"
    :replace="replace"
    :routerTag="routerTag"
    @click="clickit"
    ref="createBtn"
>
    <FaIcon icon="plus" />
    {{ $t('table.create') }}
</CLink>
</template>

<script>
import { props } from '@coreui/vue/src/components/link/CLink'

export default {
    name: 'CreateBtn',
    props: props,
    methods: {
        clickit() {
            if (!this.to) {
                this.$emit('click')
                return
            }
            this.$router.push(this.to)
        }
    }
}
</script>